// extracted by mini-css-extract-plugin
export default {"star-border":"WatchlistButton_star-border__PfJcN"};